import Salidas from "./Salidas";
export default Salidas;